@if (routerUrl$ | async; as routerUrl){
    @if (visible$ | async; as menuVisible){
        <p-drawer styleClass="admin-drawer" [visible]="menuVisible" (onHide)="onHide()" [showCloseIcon]="false" >
            <div class="admin-menu w-full sm:w-60 h-fit py-4 px-3 rounded-r-3xl bg-slate-100 my-auto">
                <div class="flex flex-col h-fit">
                    <div class="w-full border-b pb-2">
                        <p class="text-center font-semibold">Event Admin</p>
                    </div>
                    <a [class.active]="routerUrl === '/admin/events/new'" class="mb-2" [routerLink]="['/admin','events','new']">Create An Event</a>
                    <hr>
                    <a [class.active]="routerUrl === '/admin'" [routerLink]="['/admin']">My Upcoming Events</a>
                    <a [class.active]="routerUrl === '/admin/archive'" [routerLink]="['/admin','archive']">Event Archive</a>
                    <div class="w-full my-2 border-b pb-2">
                        <p class="text-center font-semibold">Organiser Admin</p>
                    </div>
                    <a>Manage Event Hosts</a>
                    <a>Manage Event Systems</a>
                    <a>Manage E-mails</a>
                    <a>Manage Monster Manual</a>
                    <div class="w-full my-2 border-b pb-2">
                        <p class="text-center font-semibold ">Administration</p>
                    </div>
                    <a [class.active]="routerUrl === '/admin/users'" [routerLink]="['/admin','users']">Manage Permissions</a>
                    <a>Manage Site Policies</a>
                    <a>Manage FAQ</a>
                    <a>System Config</a>
                </div>
            </div>
        </p-drawer>
    }
}